import React, { Component } from 'react';
import { withStyles, Grid, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: '1%'
    },
    box: {
        width: "950px !important"
    },
    p: {
        fontSize: '1.5em',
        textAlign: 'center',
        fontWeight: 600
    },
    button: {
        padding: '0',

        border: '1px solid #2c2b29',
        '&:hover': {
            border: '1px solid #93d0f2',
            backgroundColor: 'transparent'
        }
    }
});

const ImageComp = (props) => {
    const { image, handleNext, classes } = props
    let path
    if(image.IMAGEPATH.indexOf('https') >= 0) {
        if (image.landscape) {
            path = `${image.IMAGEPATH}?wid=220`
        } else {
            path = `${image.IMAGEPATH}?hei=220`
        }
        if(image.rotate) {
            path+= `&rotate=${image.rotate}`
        }
        path+= `&fmt=jpg`
    } else {
        path = `https://s3.amazonaws.com/events.gemvision.com/${image.IMAGEPATH}`
    }

    let imgStyle = { borderRadius: '4px', overflow:'hidden'}
    if(image.landscape) {
        imgStyle.width= '220px'
        imgStyle.height = 'auto'
    } else {
        imgStyle.width= 'auto'
        imgStyle.height = '220px'
    }
    return (
        <Grid  container item xs={3} justify="center" style={{ padding: '10px' }}>
            <Button
                className={classes.button}
                onClick={() => handleNext(image.STYLE)}>
                <img src={path} style={imgStyle} alt="icon export" />
            </Button>
        </Grid>
    )
}

class StepsComponent extends Component {
    render() {
        const { classes, stepsNumber, images, handleNext } = this.props;
        if (!images) {
            return (
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                    style={{ minHeight: '50vh' }}>
                    <Grid item xs={3}>
                        <h1>Loading ...</h1>
                        <CircularProgress size="100px" variant="indeterminate" />
                    </Grid>
                </Grid>
            )
        }
        return (
            <div className={classes.wrapper}>
                <Grid container className={classes.box}>
                    <Grid container item xs={12} justify="center" style={{ borderBottom: '1px solid #93d0f2', margin: '25px 0' }}>
                        <p className={classes.p}> Select the image out of this group that is the most appealing to you …</p>
                    </Grid>
                    {images.map((element, index) => <ImageComp key={`${element.STYLE}_${index}`} classes={classes} image={element} handleNext={handleNext} />)}
                    <Grid container item xs={12} justify="center" style={{ borderTop: '1px solid #93d0f2', margin: '25px 0' }}>
                        <p>{stepsNumber}/10</p>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(StepsComponent);

